import { useTranslation } from "react-i18next";
import {
    Card,
    CardContent,
    CardHeader,
    Divider,
    Typography,
    FormControlLabel,
    CardActions,
    Checkbox,
    Box
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useEffect, useState } from "react";
import { ROLES } from "src/constants";
import { useSelector } from "react-redux";

export default function DriversOrdersSettings({
    data,
    onConfirm,
    loading,
    error,
    isSuccess
}) {

    const { t } = useTranslation();
    const { profile } = useSelector((state) => state.entities.profile)

    const [driverSettings, setDriverSettings] = useState({
        pickByButton: false,
        completeByDriver: false,
        driverDeliveryAccept: false,
    });

    const handleChange = (event) => {
        setDriverSettings({
            ...driverSettings,
            [event.target.name]: event.target.checked
        });
    }


    useEffect(() => {
        if (data) {
            setDriverSettings({
                pickByButton: data?.pickByButton,
                completeByDriver: data?.completeByDriver,
                driverDeliveryAccept: data?.driverDeliveryAccept
            });
        }
    }, [data]);


    return (
        <Card>
            <CardHeader title={t("Drivers Settings")} />
            <Divider />
            <CardContent>
                <FormControlLabel
                    control={
                        <Checkbox
                            name="pickByButton"
                            checked={driverSettings?.pickByButton}
                            onChange={handleChange}
                            inputProps={{ 'aria-label': 'controlled' }}
                        />
                    }
                    label={t("Confirm picking up the task's orders without scanning them.")}
                />
                <FormControlLabel
                    control={
                        <Checkbox
                            name="completeByDriver"
                            checked={driverSettings?.completeByDriver}
                            onChange={handleChange}
                            inputProps={{ 'aria-label': 'controlled' }}
                        />
                    }
                    label={t("Confirm delivery of orders to the warehouse or merchant manually.")}
                />
                {
                    profile?.role === ROLES.admin &&
                    <>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    name="driverDeliveryAccept"
                                    checked={driverSettings?.driverDeliveryAccept}
                                    onChange={handleChange}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />
                            }
                            label={t("Give the driver the option to accept/reject the assigned orders to him.")}
                        />
                    </>
                }
            </CardContent>
            <Divider />
            <CardActions>
                {isSuccess && <Typography color="success.main">{t("Updated successfully")}</Typography>}
                {!!error && <Typography color="error">{error}</Typography>}
                <Box mr="auto" />
                <LoadingButton
                    variant="contained"
                    loading={loading}
                    onClick={() => onConfirm(driverSettings)}
                >{t("Confirm")}
                </LoadingButton>
            </CardActions>
        </Card>
    );
};

